import { ArrowOutward } from "@mui/icons-material"
import { Fade, Grid, TableRow, Typography } from "@mui/material"
import { Link } from "react-router-dom"
import { RankOneIcon, RankThreeIcon, RankTwoIcon } from "../../assets"
import { LeaderboardData, ReferralsData } from "../../stores/global"
import { CustomizedTablesProps, StyledTableCell } from "../commons/CompactTable"
import { truncateStr } from "../commons/utils"

export const tableHeadersReferral: CustomizedTablesProps['tableHeader'] = [
  { label: 'My Referrals', props: { sx: { paddingLeft: '1.5rem' } } },
  { label: 'Date Joined' },
  { label: 'Friend Points' },
  { label: 'Referral Points' },
]

export const constructReferralTable = (datas: ReferralsData[]) => {
  return datas.map((data, index) => {
    const { referee, date, friendPoints, points } = data
    const animationTimeout = (2000 * index + 1) > 3000 ? 3000 : 2000 * index + 1
    return (
      <Fade in={true} timeout={animationTimeout}>
        <TableRow>
          <StyledTableCell sx={{ paddingLeft: '1.5rem' }}>
            <Grid container alignItems={'center'} gap={1} flexWrap={'nowrap'}>
              <Typography variant='body5'>{truncateStr(referee)}</Typography>
              <Link to={`https://xt4scan.ngd.network/address/${referee}`} style={{ textDecoration: 'none', color: 'inherit' }} >
                <ArrowOutward sx={{ fontSize: '1.2rem', verticalAlign: 'bottom' }} />
              </Link>
            </Grid>
          </StyledTableCell>
          <StyledTableCell align="left">
            <Typography variant='body5'>{date}</Typography>
          </StyledTableCell>
          <StyledTableCell align="left">
            <Typography variant='body5'>{friendPoints}</Typography>
          </StyledTableCell>
          <StyledTableCell align="left">
            <Typography variant='body5'>{points}</Typography>
          </StyledTableCell>
        </TableRow>
      </Fade>
    )
  })
}

export const tableHeadersLeaderboard: CustomizedTablesProps['tableHeader'] = [
  // { label: 'Assets', props: { sx: { paddingLeft: '1.5rem' } } }, example of how to add props
  { label: 'Rank', props: { sx: { paddingLeft: '1.5rem' } } },
  { label: 'Address' },
  { label: 'Deposit Points' },
  { label: 'Borrow Points' },
  { label: 'Referral Points' },
  { label: 'Total Points' },
]

export const constructLeaderboardTable = (datas: LeaderboardData[]) => {

  return datas.map((data, index) => {
    const { rank, address, depositPoints, borrowPoints, referralPoints, totalPoints } = data
    // const AssetIcon = icon ? icon : <></>
    const animationTimeout = (2000 * index + 1) > 3000 ? 3000 : 2000 * index + 1
    let rankDisplay: any = rank
    if (rank === 1) {
      rankDisplay = <RankOneIcon />
    }
    else if (rank === 2) {
      rankDisplay = <RankTwoIcon />
    }
    else if (rank === 3) {
      rankDisplay = <RankThreeIcon />
    }
    return (
      <Fade in={true} timeout={animationTimeout}>
        <TableRow>
          <StyledTableCell sx={{ paddingLeft: '1.5rem' }}>
            <Grid container alignItems={'center'} gap={1} flexWrap={'nowrap'}>
              <Typography variant='s'>{rankDisplay}</Typography>
            </Grid>
          </StyledTableCell>
          <StyledTableCell align="left">
            <Grid container alignItems={'center'} gap={1} flexWrap={'nowrap'}>
              <Typography variant='s'>{truncateStr(address)}</Typography>
              <Link to={`https://xt4scan.ngd.network/address/${address}`} style={{ textDecoration: 'none', color: 'inherit' }} >
                <ArrowOutward sx={{ fontSize: '1.2rem', verticalAlign: 'bottom' }} />
              </Link>
            </Grid>
          </StyledTableCell>
          <StyledTableCell align="left">
            <Typography variant='s'>{depositPoints}</Typography>
          </StyledTableCell>
          <StyledTableCell align="left">
            <Typography variant='s'>{borrowPoints}</Typography>
          </StyledTableCell>
          <StyledTableCell align="left">
            <Typography variant='s'>{referralPoints}</Typography>
          </StyledTableCell>
          <StyledTableCell align="left">
            <Typography variant='s'>{totalPoints}</Typography>
          </StyledTableCell>
        </TableRow>
      </Fade>
    )
  })
}